export enum PublishTopic {
    ADD_HISTORY_ASSET = 'ADD_HISTORY_ASSET',
    ASSET_INFO_UPDATED = 'ASSET_INFO_UPDATED',
    WORKSPACES_LOADED = 'WORKSPACES_LOADED',
    MAP_ZOOM_CHANGE = 'MAP_ZOOM_CHANGE',
    MAP_ZOOM_TO_LOCATION = 'MAP_ZOOM_TO_LOCATION',
    USER_SETTINGS_LOADED = 'USER_SETTINGS_LOADED',
    UPDATE_ASSET_TELEMETRY = 'UPDATE_ASSET_TELEMETRY',
    ONLY_SHOW_ON_MAP = 'ONLY_SHOW_ON_MAP',
    MARKER_CLICKED = 'MARKER_CLICKED',
    FOLDER_SWITCH = 'FOLDER_SWITCH',
    ASSETS_LOADED = 'ASSETS_LOADED',
    WORKSPACES_RELOADED = 'WORKSPACE_RELOADED',
    GEOFENCES_CHANGED = 'GEOFENCES_CHANGED',
    ROCKPITS_CHANGED = 'ROCKPITS_CHANGED',
    MARKER_CREATED = 'MARKER_CREATED',
    AVL_MAP_LOADED = 'AVL_MAP_LOADED',
    OOS_STATUS_CHANGED = 'OOS_STATUS_CHANGED',
    PM_UPDATED = 'PM_UPDATED',
}
